import type { LabeledValuePayload } from '@Application/Users/UserStatuses/Actions/userStatusesFetched';

export type AccountWorkflowPayload = {
	readonly key: string;
	readonly label: string;
	readonly launchMode: LabeledValuePayload;
	readonly isActive: boolean;
};

export type AccountWorkflowsFetchedPayload = AccountWorkflowPayload[];

export type AccountWorkflowsFetchedAction = {
	type: 'ACCOUNT_WORKFLOWS_FETCHED';
	payload: AccountWorkflowsFetchedPayload;
	accountId: number;
};

export default (
	payload: AccountWorkflowsFetchedPayload,
	accountId: number,
): AccountWorkflowsFetchedAction => ({
	type: 'ACCOUNT_WORKFLOWS_FETCHED',
	payload,
	accountId,
});
